import { useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import theme from 'constants/theme';
import { useState, useCallback } from 'react';

import { Stack } from 'components/Stack';
import { Text } from 'components/Typography';
import { ReactComponent as IcArrowRight } from 'constants/icon/ic_arrowright.svg';
import { ReactComponent as IcSetting } from 'constants/icon/ic_setting.svg';

import { useGetPaymentMy } from 'hooks/query/payment/useGetPaymentMy';
import { useIsDifferenceStore, useMessageModalStore } from 'pages/Message/common/MessagePromptStore';

type TRequired = {
  isFolded: boolean;
};

const navWidth: number = 200;
const btnIconWidth: number = 24;

const SettingSection = ({
  label,
  path,
  currentPath,
  navigate,
}: {
  currentPath: string;
  label: string;
  path: string;
  navigate: (path: string) => void;
}) => {
  const [isOpenUpgradeGuideModal, setIsOpenUpgradeGuideModal] = useState<boolean>(false);

  const { data: paymentMyData } = useGetPaymentMy({
    refetchOnWindowFocus: true,
  });

  return (
    <Stack align="start" spacing={10}>
      <NavItem
        style={{ fontSize: 14 }}
        isActive={path === currentPath}
        // disabled={item.disabled}
        onClick={() => {
          //   if (item.disabled) return;

          //   if (
          //     (item.key === 'app' || item.key === 'masterOrder' || item.key === 'multiSkill') &&
          //     paymentMyData?.name === 'Free'
          //   ) {
          //     setIsOpenUpgradeGuideModal(true);

          //     return;
          //   }

          navigate(path);
        }}
      >
        {label}
      </NavItem>
      {/* <UpgradeGuideModal
          isOpen={isOpenUpgradeGuideModal}
          setIsOpen={setIsOpenUpgradeGuideModal}
          upgradeGuidePlan={['Lite', 'Standard', 'Pro', 'Enterprise']}
          text="요금제로 업그레이드 하시면 해당 기능을 사용하실 수 있습니다."
        /> */}
    </Stack>
  );
};

const MessageNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isDifference } = useIsDifferenceStore();
  const { openModal } = useMessageModalStore();
  const currentPath = location?.pathname.split('/')[location?.pathname.split('/').length - 1];
  const [isFolded, setIsFolded] = useState<boolean>(false);

  const nav_contents = [
    { path: 'manual', lable: '메시지 수동 발송' },
    { path: 'auto', lable: '알림메시지 자동 설정' },
    { path: 'history', lable: '발송 이력 조회' },
  ];

  const handleNavigate = useCallback(
    (path: string) => {
      if (isDifference) {
        openModal(() => {
          navigate(path);
        });
      } else {
        navigate(path);
      }
    },
    [navigate, isDifference, openModal]
  );
  return (
    <NavWrapper {...{ isFolded }}>
      <NavControlButton
        onClick={() => {
          setIsFolded(!isFolded);
        }}
        {...{ isFolded }}
      >
        <IcArrowRight
          width={10}
          style={{
            rotate: isFolded ? '0deg' : '180deg',
          }}
        />
      </NavControlButton>

      {isFolded ? null : (
        //main content here
        <Stack spacing={32} useVerticalScroll sx={{ height: '100%', width: 'calc(100% + 24px)' }}>
          <Stack direction="row" spacing={6}>
            <IcSetting width={16} height={16} fill={theme.colors.RG06} />
            <Text styleName="subheadline1" color="RG03">
              메시지 관리
            </Text>
          </Stack>
          <Stack>
            {nav_contents.map(item => (
              <Stack key={item?.path} align="start" spacing={6} style={{ gap: 6 }}>
                <NavItem
                  isActive={item.path === currentPath}
                  style={{ fontSize: 14 }}
                  // disabled={item.disabled}
                  onClick={() => {
                    handleNavigate(item.path);
                  }}
                >
                  {item.lable}
                </NavItem>
              </Stack>
            ))}
          </Stack>

          {/* {Object.keys(nav_contents).map(key => {
            const { label, items } = nav_contents[key];
            return <SettingSection {...{ label, items, current, setCurrent }} />;
          })} */}
        </Stack>
      )}
    </NavWrapper>
  );
};

export default MessageNavigation;

const NavWrapper = styled.div<TRequired>`
  position: relative;
  flex-shrink: 0;

  height: 100%;

  ${({ theme, isFolded }) => {
    return {
      width: isFolded ? `24px` : `${navWidth}px`,
      padding: isFolded ? '' : '40px 20px',

      borderLeft: `1px solid ${theme.colors.RG06}`,
      borderRight: `1px solid ${theme.colors.RG06}`,
    };
  }};
`;

const NavControlButton = styled.button<TRequired>`
  position: absolute;
  z-index: 8;

  top: 38px;

  width: ${btnIconWidth}px;
  height: ${btnIconWidth}px;

  ${({ theme, isFolded }) => ({
    left: isFolded ? `${btnIconWidth / 2}px` : `${navWidth - 12}px`,

    background: theme.colors.RG00,
    border: `1px solid ${theme.colors.RG06}`,
  })}
  border-radius: ${btnIconWidth / 2}px;

  cursor: pointer;
`;

const NavItem = styled.div<{
  isActive?: boolean;
  disabled?: boolean;
}>`
  ${({ theme }) => theme.fontStyle.caption2}
  width: calc(100% - 24px);
  height: 100%;

  padding: 6px 8px;
  border-radius: 8px;

  color: ${({ theme }) => theme.colors.RG02};
  background-color: transparent;

  ${({ isActive, theme }) => isActive && theme.fontStyle.caption1};

  ${({ isActive, theme }) =>
    isActive && {
      color: theme.colors.RC02,
      backgroundColor: theme.colors.RC03_1,
    }}
  &.active {
    ${({ theme }) => theme.fontStyle.caption1}
    color: ${({ theme }) => theme.colors.RC02};
    background-color: ${({ theme }) => theme.colors.RC03_1};
  }

  cursor: pointer;

  ${({ disabled, theme }) =>
    disabled && {
      cursor: 'not-allowed',
      color: theme.colors.RG04,
    }}
`;
